module.exports = "<vdg-controller></vdg-controller>\n\n"